import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview"]
  static values = { prefix: String, labelText: String }

  declare readonly inputTarget: HTMLInputElement
  declare readonly previewTarget: HTMLElement
  declare readonly hasPreviewTarget: boolean
  declare readonly prefixValue?: string
  declare readonly labelTextValue?: string

  connect() {
    this.updatePreview()
  }

  updatePreview() {
    if (!this.hasPreviewTarget) return
    const value = this.inputTarget?.value?.trim() || ""
    if (value.length === 0) {
      this.previewTarget.textContent = ""
      this.previewTarget.classList.add("hidden")
      return
    }
    this.previewTarget.classList.remove("hidden")
    let label = this.labelTextValue || this.prefixValue || ""
    label = label.replace(/label/i, "").trim()
    this.previewTarget.textContent = `PREVIEW: ${label} - ${value}`.replace(/ - $/, "")
  }
}
